import "../stakeholderlayout.css";

export default function Individuals() {
  return (
    <section className="page-wrapper">
      <div className="container">

        {/* Hero Section */}
        <h2 className="hero-title">
          Structured Guidance for Individuals, Families & Communities
        </h2>

        <h3 className="hero-subtitle">
          Clarity in education, career pathways, institutional navigation,
          and community coordination.
        </h3>

        <p className="hero-text">
          Many personal and family challenges are failures of structure,
          coordination, and long-term planning — not effort.
        </p>

        <div className="button-group">
          <button className="primary-btn">
            Describe Your Situation
          </button>
          <button className="secondary-btn">
            Request Structured Guidance
          </button>
        </div>

        <p className="form-note">
          We treat personal matters with discretion and seriousness.
        </p>

        {/* Reality */}
        <h2 className="section-title">
          The Modern Personal & Social Reality
        </h2>

        <ul className="problem-list">
          <li>Conflicting career narratives</li>
          <li>Institutional complexity</li>
          <li>Financial uncertainty</li>
          <li>Intergenerational misalignment</li>
          <li>Weak long-term planning frameworks</li>
        </ul>

        <p className="insight-text">
          Most of these challenges are systemic.
        </p>

        {/* Breakdown */}
        <h2 className="section-title">
          Where Clarity Is Often Missing
        </h2>

        <ol className="challenges-list">
          <li><strong>Education & Career Pathways</strong></li>
          <li><strong>Institutional Navigation</strong></li>
          <li><strong>Financial & Life Planning</strong></li>
          <li><strong>Family Governance</strong></li>
          <li><strong>Community Coordination</strong></li>
        </ol>

        {/* Structured Support */}
        <h2 className="section-title">
          Structured Support Architecture
        </h2>

        <h3 className="subsection-title">
          SECTION A: Education & Career Systems
        </h3>

        <ul className="focus-list">
          <li>Capability mapping</li>
          <li>Education roadmap design</li>
          <li>Decision matrices</li>
        </ul>

        <button className="btn explore">
          Explore Education & Career Guidance
        </button>

        <h3 className="subsection-title">
          SECTION B: Institutional Navigation
        </h3>

        <ul className="focus-list">
          <li>Regulatory understanding</li>
          <li>Structured evaluation of options</li>
        </ul>

        <button className="btn explore">
          Explore Institutional Navigation Support
        </button>

        <h3 className="subsection-title">
          SECTION C: Family & Community Governance
        </h3>

        <ul className="focus-list">
          <li>Role clarity frameworks</li>
          <li>Decision protocols</li>
          <li>Conflict reduction structures</li>
        </ul>

        <button className="btn explore">
          Explore Governance Support
        </button>

        {/* Boundaries */}
        <h2 className="section-title">
          What We Do — and What We Do Not Do
        </h2>

        <ul className="problem-list">
          <li>Provide structured thinking</li>
          <li>Offer systemic clarity</li>
          <li>Design decision frameworks</li>
        </ul>

        <p className="principle-text">
          We do not provide therapy, legal representation, or guaranteed outcomes.
        </p>

        {/* Action */}
        <h2 className="section-title">
          Start a Structured Conversation
        </h2>

        <div className="button-group">
          <button className="primary-btn">
            Describe Your Situation
          </button>
          <button className="secondary-btn">
            Request Guidance Session
          </button>
        </div>

        <p className="footer-note">
          We approach individual and community matters with dignity,
          discretion, and institutional seriousness.
        </p>

      </div>
    </section>
  );
}
